import { ImageSources } from '../../types';
import { createSrcSet } from '../create-src-set';

/**
 * @todo подумать над кешированием результатов
 */
export const prefetch = (sources: ImageSources) =>
  new Promise((resolve, reject) => {
    const link = document.createElement('link');

    link.addEventListener('load', function () {
      resolve(this);
    });

    link.addEventListener('error', (event) => {
      reject(new Error('[image]: prefetch failed', { cause: event }));
    });

    link.rel = 'prefetch';
    link.as = 'image';
    link.imageSrcset = createSrcSet(sources);

    document.head.appendChild(link);
  });
